export const zhCnLocale = {
  model: {
    customPage: '自定义页面'
  },
  customPage: {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    default: '预置页面',
    miniProgramPath: '小程序路径',
    formalCustomPageId: 'Formal custom page',
    canRollbackData: 'Can rollback data',
    configs: '自定义页面',
  }
}

export const enLocale = {
  model: {
    customPage: 'Custom page'
  },
  customPage: {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    slug: 'Slug',
    default: 'Default',
    miniProgramPath: 'Mini program path',
    formalCustomPageId: 'Formal custom page',
    canRollbackData: 'Can rollback data',
    configs: 'Configs',
  }
}

